document.addEventListener("DOMContentLoaded", () => {
  const bubble = document.createElement("button");
  bubble.id = "mr-candelx-bubble";
  bubble.innerHTML = `
    <span class="mr-candelx-bubble-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 10H16M8 14H13M21 11.5C21 16.1944 16.9706 20 12 20C10.3671 20 8.83564 19.5892 7.52119 18.8711L3 20L4.18602 16.1301C3.43244 14.799 3 13.2784 3 11.5C3 6.80558 7.02944 3 12 3C16.9706 3 21 6.80558 21 11.5Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
    <span class="mr-candelx-bubble-text">Chat</span>
  `;

  const panel = document.createElement("div");
  panel.id = "mr-candelx-panel";
  panel.innerHTML = `
    <div id="mr-candelx-header">
      <strong>Chat PROREUSE</strong>
      <button id="mr-candelx-close" type="button">×</button>
    </div>
    <div id="mr-candelx-messages"></div>
    <div id="mr-candelx-typing" style="display:none;">Mr Candelx sta scrivendo...</div>
    <div id="mr-candelx-input-row">
      <input id="mr-candelx-input" type="text" placeholder="Scrivi un messaggio..." />
      <button id="mr-candelx-send" type="button">Invia</button>
    </div>
  `;

  document.body.appendChild(bubble);
  document.body.appendChild(panel);

  const messages = document.getElementById("mr-candelx-messages");
  const input = document.getElementById("mr-candelx-input");
  const send = document.getElementById("mr-candelx-send");
  const closeBtn = document.getElementById("mr-candelx-close");
  const typing = document.getElementById("mr-candelx-typing");

  const sessionKey = "mr_candelx_session_id";
  const emailKey = "mr_candelx_email";

  function getSessionId() {
    let sessionId = localStorage.getItem(sessionKey);
    if (!sessionId) {
      sessionId = "chat_" + Date.now() + "_" + Math.random().toString(36).slice(2, 10);
      localStorage.setItem(sessionKey, sessionId);
    }
    return sessionId;
  }

  function getCustomerEmail() {
    return localStorage.getItem(emailKey) || "";
  }

  function setCustomerEmail(email) {
    localStorage.setItem(emailKey, email);
  }

  function extractEmail(text) {
    const match = String(text).match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
    return match ? match[0] : "";
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function formatBotText(text) {
    const escaped = escapeHtml(text);
    const withLinks = escaped.replace(
      /(https?:\/\/[^\s<]+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
    );
    return withLinks.replace(/\n/g, "<br>");
  }

  function addMessage(text, who) {
    const row = document.createElement("div");
    row.className = `mr-candelx-msg ${who}`;

    const msgBubble = document.createElement("div");
    msgBubble.className = "mr-candelx-msg-bubble";

    if (who === "bot") {
      msgBubble.innerHTML = formatBotText(text);
    } else {
      msgBubble.textContent = text;
    }

    row.appendChild(msgBubble);
    messages.appendChild(row);
    messages.scrollTop = messages.scrollHeight;
  }

  async function addToCart(variantId, button) {
    if (!variantId) return;

    const originalText = button ? button.textContent : "";

    try {
      if (button) {
        button.disabled = true;
        button.textContent = "Aggiungo...";
      }

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error("Errore add to cart");
      }

      if (button) {
        button.textContent = "✓ Aggiunto";
      }

      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:open"));
      document.body.dispatchEvent(new CustomEvent("cart:refresh"));
      document.body.dispatchEvent(new CustomEvent("cart:open"));
      window.dispatchEvent(new CustomEvent("cart:refresh"));
      window.dispatchEvent(new CustomEvent("cart:open"));

      const possibleCartTriggers = [
        '[href="/cart"]',
        '[data-cart-toggle]',
        '[data-drawer-open="cart"]',
        '[data-cart-drawer-open]',
        '.js-cart-toggle',
        '.header__icon--cart',
        '.site-header__cart',
        '.cart-icon',
        '.js-drawer-open-cart'
      ];

      let opened = false;

      for (const selector of possibleCartTriggers) {
        const el = document.querySelector(selector);
        if (el) {
          el.click();
          opened = true;
          break;
        }
      }

      if (!opened) {
        setTimeout(() => {
          window.location.href = "/cart";
        }, 500);
      }
    } catch (error) {
      console.error("Errore add to cart:", error);
      if (button) {
        button.disabled = false;
        button.textContent = "Errore";
      }
      return;
    }

    if (button) {
      setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText || "Aggiungi";
      }, 1800);
    }
  }

  function renderProducts(products) {
    if (!Array.isArray(products) || products.length === 0) return;

    const wrap = document.createElement("div");
    wrap.className = "mr-candelx-products";

    products.slice(0, 3).forEach((product) => {
      const card = document.createElement("div");
      card.className = "mr-candelx-product-card";

      const imageHtml = product.image
        ? `<img src="${product.image}" alt="${escapeHtml(product.imageAlt || product.title)}" class="mr-candelx-product-image">`
        : `<div class="mr-candelx-product-noimage">Prodotto</div>`;

      const priceHtml = product.price
        ? `<div class="mr-candelx-product-price">€ ${escapeHtml(product.price)}</div>`
        : "";

      const addToCartHtml = product.variantId
        ? `<button type="button" class="mr-candelx-product-btn mr-candelx-product-btn-primary add-to-cart-btn" data-id="${escapeHtml(product.variantId)}">Aggiungi</button>`
        : `<a class="mr-candelx-product-btn mr-candelx-product-btn-primary" href="${product.url}" target="_blank" rel="noopener noreferrer">Vedi prodotto</a>`;

      card.innerHTML = `
        ${imageHtml}
        <div class="mr-candelx-product-body">
          <div class="mr-candelx-product-title">${escapeHtml(product.title)}</div>
          ${priceHtml}
          <div class="mr-candelx-product-actions">
            <a class="mr-candelx-product-btn mr-candelx-product-btn-secondary" href="${product.url}" target="_blank" rel="noopener noreferrer">Apri</a>
            ${addToCartHtml}
          </div>
        </div>
      `;

      wrap.appendChild(card);
    });

    messages.appendChild(wrap);
    messages.scrollTop = messages.scrollHeight;

    wrap.querySelectorAll(".add-to-cart-btn").forEach((btn) => {
      btn.addEventListener("click", async () => {
        const variantId = btn.getAttribute("data-id");
        await addToCart(variantId, btn);
      });
    });
  }

  bubble.addEventListener("click", () => {
    panel.classList.toggle("open");
    if (panel.classList.contains("open") && messages.children.length === 0) {
      addMessage(
        "Ciao 👋 Posso aiutarti a scegliere i prodotti giusti. Per iniziare, scrivimi pure anche la tua email così sappiamo con chi stiamo parlando.",
        "bot"
      );
    }
  });

  closeBtn.addEventListener("click", () => {
    panel.classList.remove("open");
  });

  async function sendMessage() {
    const text = input.value.trim();
    if (!text) return;

    const foundEmail = extractEmail(text);
    if (foundEmail) {
      setCustomerEmail(foundEmail);
    }

    addMessage(text, "user");
    input.value = "";
    typing.style.display = "block";

    try {
      const res = await fetch("https://shopify-ai-chat-production-d71a.up.railway.app/chat", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          message: text,
          sessionId: getSessionId(),
          pageUrl: window.location.href,
          customerEmail: getCustomerEmail()
        })
      });

      const data = await res.json();
      typing.style.display = "none";

      if (data.customerEmail) {
        setCustomerEmail(data.customerEmail);
      }

      addMessage(data.reply || "Errore nella risposta.", "bot");
      renderProducts(data.products || []);
    } catch (error) {
      typing.style.display = "none";
      addMessage("Errore di collegamento al server.", "bot");
    }
  }

  send.addEventListener("click", sendMessage);

  input.addEventListener("keydown", (event) => {
    if (event.key === "Enter") {
      sendMessage();
    }
  });
});